/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
// import 'date-fns';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// import moment from 'moment';
import useDebounce from '../../../utils/useDebounce';

const Toolbar = (props) => {
  const {
    setSlugName,
    setProductGroup,
    setProductType,
    deleted,
    setDeleted,
  } = props;


  const [searchSlugNameTyped, setSearchSlugNameTyped] = useState('');
  const debouncedSearchSlugName = useDebounce(searchSlugNameTyped, 500);
  useEffect(() => {
    setSlugName(searchSlugNameTyped);
  }, [debouncedSearchSlugName]);

  const [searchProductGroupTyped, setSearchProductGroupTyped] = useState('');
  const debouncedSearchProductGroup = useDebounce(searchProductGroupTyped, 500);
  useEffect(() => {
    setProductGroup(searchProductGroupTyped);
  }, [debouncedSearchProductGroup]);

  // const handleChangeRange = (event, newValue) => {
  //   rangeSetValue(newValue);
  // };
  // const setRangeFilter = (event, newValue) => {
  //   setPriceFilter(newValue);
  // };

  return (
    <div className="flex">

      <div className="flex w-1/6 my-6 items-center">
        <label htmlFor="toggle" className="block uppercase tracking-wide text-gray-700 text-xs font-bold mr-2">Only Deleted</label>
        <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
          <input
            type="checkbox"
            name="toggle"
            id="toggle"
            value={!!deleted}
            onChange={() => setDeleted(!deleted)}
            checked={!!deleted}
            className="outline-none toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
          />
          <label htmlFor="toggle" className="toggle-label block overflow-hidden h-6 rounded-full bg-grey cursor-pointer" />
        </div>
      </div>

      <div className="px-3 md:mb-0">
        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
          Product Type
        </label>
        <div className="relative">
          <select
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            onChange={e => setProductType(e.currentTarget.value)}
          >
            <option value="">All</option>
            <option value="event">Event</option>
            <option value="subscription">Subscription</option>
            <option value="present">Present</option>
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 h-12 top-0">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>

      <div className="w-1/5 px-3 md:mb-0">
        <label
          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          htmlFor="searchSlugNameTyped"
        >
          Product slug name
        </label>
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="searchSlugNameTyped"
          type="text"
          onChange={e => setSearchSlugNameTyped(e.target.value)}
          value={searchSlugNameTyped}
        />
      </div>

      <div className="w-1/5 px-3 md:mb-0">
        <label
          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          htmlFor="searchProductGroupTyped"
        >
          Product Group
        </label>
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="searchProductGroupTyped"
          type="text"
          onChange={e => setSearchProductGroupTyped(e.target.value)}
          value={searchProductGroupTyped}
        />
      </div>
    </div>
  );
};

Toolbar.propTypes = {
  setSlugName: PropTypes.func.isRequired,
  setProductGroup: PropTypes.func.isRequired,
  setProductType: PropTypes.func.isRequired,
  deleted: PropTypes.bool,
  setDeleted: PropTypes.func.isRequired,
};

Toolbar.defaultProps = {
  deleted: false,
};

export default Toolbar;
